module.exports = __webpack_public_path__ + "static/r4-d1250cbcbb002fa41c16df747481ffa9.jpg";